import _ from 'lodash';
import moment from 'moment';
import errorReporter from '@app/errorReporter';
import {
  formatActionTaken,
  formatNonAgentStatus,
  formatPhoneNumber,
  featureEnabled,
  isValidUrl,
} from 'utils';
import { parseLabelFromString } from 'contexts';
import template from './appointment_confirm.html';
import { areAppointmentInstructionsInvalid } from './areAppointmentInstructionsInvalid';
import { NA_TYPE_MAP } from '../../constants/index';

angular.module('bb.appointments').component('bbAppointmentConfirm', {
  bindings: {},
  controller: AppointmentConfirmCtrl,
  controllerAs: 'vm',
  template,
});

AppointmentConfirmCtrl.$inject = [
  '$resource',
  '$rootScope',
  '$routeParams',
  'loadContacts',
  '$q',
  'AppointmentBookService',
  'AppointmentConfigService',
];

function AppointmentConfirmCtrl(
  $resource,
  $rootScope,
  $routeParams,
  loadContacts,
  $q,
  AppointmentBookService,
  AppointmentConfigService,
) {
  const vm = this;
  vm.auth = $rootScope.auth;
  vm.viewDashAppointment = $rootScope.viewDashAppointment;
  vm.openContactDrawer = $rootScope.openContactDrawer;

  vm.accesses = [
    { id: '', label: $rootScope.hasFeature('SUPRA_MVP') ? 'Unassign' : '' },
    { id: 'Direct', label: 'Direct' },
    { id: 'Key', label: 'Key' },
    { id: 'Door Code', label: 'Door Code' },
  ];

  vm.naTypeMap = NA_TYPE_MAP;

  const Appointment = $resource('/appointments/:appointmentId', {
    appointmentId: '@appointmentId',
  });
  const CovidAction = $resource('/covid19/appointment/updateAction', {
    appointmentId: '@appointmentId',
  });
  const SendDetails = $resource('/appointments/send/:appointmentId/confirm', {
    appointmentId: '@appointmentId',
  });
  const AppointmentList = $resource('/listing/:listingId/appointments', {
    listingId: '@listingId',
  });
  const OfferCount = $resource('/listing/:listingId/offer_count', {
    listingId: '@listingId',
  });

  vm.action = {
    tab: 'history',
    restrictions: 'weekly',
  };

  Appointment.get({ appointmentId: $routeParams.appointmentId })
    .$promise.then(data => {
      vm.appointment = data.appointment;
      vm.isCovidFlagEnabled = vm.appointment?.orgHasCovidFlag;
      vm.listing = data.listing;
      vm.listingLink = `#/listing/${vm.listing.id}/view`;
      vm.mlsTypes = data.listing.org?.mlsTypes.length
        ? data.listing.org.mlsTypes
        : null;

      AppointmentConfigService.getListingAppointmentConfig(vm.listing.id)
        .then(appointmentConfig => {
          const agentIds = appointmentConfig.contacts
            .filter(contact => contact.type === 'Agent')
            .map(contact => contact.contactId);
          loadContacts($resource, vm, $q, vm.listing.id, agentIds).catch(
            errorReporter.error,
          );

          let showCombinationLockbox = true;
          if (featureEnabled('launchByAssociationFeature', 1)) {
            showCombinationLockbox =
              appointmentConfig?.lockboxVendorSettings?.combinationLockbox;
          } else {
            if (vm.auth.org?.lockboxVendorSettings) {
              showCombinationLockbox =
                vm.auth.org?.lockboxVendorSettings?.combinationLockbox;
            }
          }

          if (showCombinationLockbox) {
            vm.accesses.push({
              id: 'Lock Box',
              label: 'Combination Lock Box',
            });
          }

          const { pendingDelivery } = vm.appointment;
          vm.isConciergeDelivery =
            pendingDelivery &&
            !pendingDelivery.deliverCoop &&
            pendingDelivery.deliverConcierge;

          let mustCall = false;
          appointmentConfig.contacts.forEach(contact => {
            if (
              contact.phone &&
              contact.phone.filter(phoneInfo => phoneInfo.mustCall).length
            ) {
              mustCall = true;
            }
          });
          vm.mustCallContacts =
            mustCall &&
            vm.appointment.isPending &&
            appointmentConfig.autoConfirm;
          vm.appointmentConfig = appointmentConfig;
          if (vm.appointment.appointmentConfig) {
            vm.appointmentConfig = {
              ...vm.appointmentConfig,
              ...vm.appointment.appointmentConfig,
            };
          }

          /**
           * Add these access options for the selected option when access in appointment config is one of them.
           */
          const accessLabelMap = {
            SentriLock: 'SentriLock 1-Day Code',
            'SentriLock App': 'SentriLock App',
            SentriLockV2: 'SentriLock',
            MasterLock: 'Master Lock',
            'Supra Lockbox': 'Supra',
          };

          if (accessLabelMap[vm.appointmentConfig.access]) {
            vm.accesses.push({
              id: vm.appointmentConfig.access,
              label: accessLabelMap[vm.appointmentConfig.access],
            });
          }

          vm.confirmation = {
            appointmentId: $routeParams.appointmentId,
            details: {
              instructions: vm.appointmentConfig.instructions,
              access: vm.appointmentConfig.access,
            },
            isPending: false,
            notify: _.clone(data.appointment.notify),
          };

          if (
            featureEnabled('nonAgentNotificationFeature') &&
            vm.appointment.coop.nonAgentId &&
            !featureEnabled('customContactDashboardFeature')
          ) {
            vm.confirmation.notify = {
              text: false,
              email: Boolean(vm.appointment.coop.approvedNonAgent),
              office: !vm.appointment.coop.approvedNonAgent,
            };
            vm.confirmation.actionTaken = '';
          }

          if (vm.isConciergeDelivery) {
            vm.confirmation.notify = {
              text: false,
              email: false,
              office: true,
            };

            const concierge = appointmentConfig.contacts.find(
              contact => contact.type === 'Concierge',
            );

            const primaryPhone =
              concierge.phone.find(phone => phone.type === 'Primary') ||
              concierge.phone[0];

            const primaryPhoneNumber = primaryPhone?.number || '';

            vm.concierge = {
              phone: primaryPhoneNumber,
              email: concierge.email,
            };
            vm.dataLoaded = true;
          } else {
            vm.dataLoaded = true;
          }
        })
        .catch(errorReporter.error);

      OfferCount.get({ listingId: vm.listing.id })
        .$promise.then(({ count }) => {
          vm.offerCount = count;
        })
        .catch(errorReporter.error);
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentTextDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.textDeliveryLog = data;
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentEmailDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.emailDeliveryLog = data;
    })
    .catch(errorReporter.error);

  AppointmentBookService.queryAppointmentPushNotificationDelivery(
    $routeParams.appointmentId,
  )
    .then(data => {
      vm.pushNotificationDeliveryLog = data;
    })
    .catch(errorReporter.error);

  vm.areAppointmentInstructionsInvalid = () =>
    areAppointmentInstructionsInvalid(
      vm.confirmation.details.access,
      vm.confirmation.details.instructions,
    );

  vm.hasListingContact = contact =>
    Object.keys(vm.listingContacts || {}).includes(
      contact.id || contact.contactId,
    );

  vm.hasNonAgentNotificationFeature = featureEnabled(
    'nonAgentNotificationFeature',
  );

  vm.formatNonAgentStatus = formatNonAgentStatus;

  // Move me into utils later
  vm.formatNonAgentNotification = () => {
    const naNameMap = {
      'Pest Control': 'PEST CONTROL',
      Photographer: 'PHOTOGRAPHER',
    };
    let naName = naNameMap[vm.appointment.type] || 'HOME INSPECTOR/APPRAISER';
    if (!vm.appointment.coop.isNotAgent) {
      naName = 'CUSTOM AGENT';
    }
    return `(${naName} ${
      vm.appointment.coop.approvedNonAgent ? '' : 'NOT '
    }NOTIFIED)`;
  };

  vm.formatActionTaken = ({
    status,
    originalTime,
    actionTaken,
    isPending,
    nonAgentNotified,
    date,
    auditEntry,
  }) => {
    return formatActionTaken(
      {
        date,
        auditEntry,
        status,
        originalTime,
        actionTaken,
        isPending,
        nonAgentNotified,
      },
      vm.appointment.type,
      vm.appointment.coop,
      vm.mustCallContacts,
      vm.appointment.history,
    );
  };

  vm.formatPhoneNumber = formatPhoneNumber;

  vm.simplifyPhoneInfo = phoneInfo => {
    let receivingText = false;
    const mustCall = [];
    if (phoneInfo?.length) {
      receivingText = phoneInfo.reduce((acc, phone) => {
        if (phone.mustCall && phone.number) mustCall.push(phone.number);
        if (phone.sendSms) return true;
        return acc;
      }, false);
    }
    return { receivingText, mustCall };
  };

  vm.loadAppointments = () => {
    if (vm.appointmentsLoaded) return;

    AppointmentList.query({ listingId: vm.listing.id }, appointments => {
      vm.appointments = appointments;
      vm.appointmentsLoaded = true;
    });
  };

  vm.selectSpecialDay = day => {
    vm.restrictDate = day;
  };

  vm.changeAccess = () => {
    if (vm.confirmation.details.access === 'SentriLockV2') {
      vm.confirmation.details.instructions.sentrilockv2 = {
        details:
          '**ATTN - OUT OF BOARD AGENTS** please ask LA to provide you Sentriconnect access to lockbox.',
      };
    }
  };

  vm.withinSentriLockDate = () => {
    if (
      vm.confirmation.details &&
      (vm.appointmentConfig.access === 'SentriLock' ||
        (vm.appointmentConfig.access === 'SentriLockV2' &&
          vm.appointmentConfig.instructions.sentrilockv2.isOneDayCodeEnabled))
    ) {
      return (
        moment(vm.appointment.time) < moment().add(14, 'days').endOf('day')
      );
    }
    return true;
  };

  vm.confirm = () => {
    vm.dataLoaded = false;
    if (vm.isConciergeDelivery) vm.confirmation.deliverConcierge = true;
    if (vm.confirmation.isPending) vm.confirmation.isAttempted = true;

    const confirm = new SendDetails(vm.confirmation);
    confirm.$save(({ isConciergePending }) => {
      $rootScope.viewNextAppointmentPage(
        $routeParams.appointmentId,
        !!isConciergePending,
        'confirm',
        vm.listing.id,
      );
    });
  };

  vm.override = () => {
    swal(
      {
        title: 'Override and allow showing',
        text: 'Are you sure you want to allow this showing to proceed without an acknowledgment from the showing agent?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#62cb31',
        confirmButtonText: 'Confirm',
        closeButtonText: 'Cancel',
        closeOnConfirm: true,
      },
      () => {
        const save = new CovidAction({
          appointmentId: $routeParams.appointmentId,
          note: 'COVID-19 FORM OVERRIDDEN',
          type: 'override',
          skipDelivery: true,
        });
        save.$save().then(() => {
          vm.appointment.covid19Signed = true;
        });
      },
    );
  };

  vm.showPicker = () => {
    const processResults = results => {
      const PDF = results.filesUploaded[0].url;
      const save = new CovidAction({
        appointmentId: $routeParams.appointmentId,
        note: 'PDF ADDED',
        type: 'PDF',
        PDF,
        skipDelivery: true,
      });
      save.$save().then(() => {
        vm.appointment.covid19Signed = true;
      });
    };

    const opts = {
      accept: 'application/pdf',
      maxFiles: 1,
      onFileSelected: file => {
        if (file.source === 'url' && !isValidUrl(file.originalPath))
          throw new Error('Invalid URL format. Please try again.');
      },
      onUploadDone: results => processResults(results),
    };

    const picker = fileStackClient.picker(opts);
    picker.open();
  };

  vm.isNonAdminListingAgent = () => {
    const isAgentRole = vm.auth.role === 'AGENT';
    const isListingAgent = vm.listing.repsObjectIds.includes(vm.auth.id);
    return isAgentRole && isListingAgent;
  };

  $rootScope.$watch('labelOverrideMap', () => {
    vm.relabelListingAvailability = availability =>
      $rootScope.labelOverrideMap[parseLabelFromString(availability)]?.label ||
      availability;
  });
}
